import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { Calendar, theme, notification } from 'antd';
import { getDates } from "../../API";
import {useLocation  } from "react-router-dom";
import locale from 'antd/es/date-picker/locale/es_ES';

import dayjs from 'dayjs';
import 'dayjs/locale/es';
dayjs.locale('es');

const ImgCalendar = ({ onValueChange }) => {
  const location = useLocation();
  const { cropid } = useParams();
  const { token } = theme.useToken();

  const wrapperStyle = {
    maxWidth: '600px',
    width: '100%',
    margin: '0 auto',
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG,
  };

  const [eventos, setEventos] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    getDates(cropid).then((res) => {
      //console.log(res);
      setEventos(res);
    });
  }, [cropid]);

  const onPanelChange = (value, mode) => {
    //console.log(value.format('YYYY-MM-DD'), mode);
  };

  const onSelect = (date, { source }) => {
    if (source === 'date') {
      let _date = new Date(date);
      _date.setHours(0,0,0);
      let formattedDate = _date.toISOString().slice(0, 10);
      if(typeof eventos[formattedDate]==='string'){
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('date', formattedDate);        
        setSelectedData(true);
        onValueChange(formattedDate);
      }else{
        notification.info({
          'message':'Monitor',
          'description': 'No hay registro del día '+formattedDate
        });        
      }
    }
  };

  const fullCellRender = (date) => {
    const event = typeof eventos[date.format('YYYY-MM-DD')]==='string'
    const cellStyle = {
      backgroundColor: event ? 'blue' : 'transparent',
      borderRadius: '10%',
      color: event ? 'white' : 'inherit',
    };

    return (
      <div style={cellStyle}>
        <div>{date.date()}</div>
      </div>
    );
  };

  return (
    <div style={wrapperStyle}>

      <Calendar
        fullscreen={false}
        onPanelChange={onPanelChange}
        fullCellRender={fullCellRender}
        locale={locale}
        onSelect={onSelect}
      />

      {selectedData && (
        <div>
          <h2>{selectedData.title}</h2>
          <p>{selectedData.description}</p>
        </div>
      )}
    </div>
  );
};

export default ImgCalendar;